<template>
  <div>
    <v-dialog v-model="show" persistent max-width="70%">
      <v-card>
        <v-app-bar dense dark text color="secondary">
          <v-toolbar-title class="subheading">{{ $t("participants.title") }}</v-toolbar-title>

          <v-spacer></v-spacer>

          <v-checkbox
            v-model="search_params.show_all"
            :label="$t('global.show_all')"
            @change="filter"
            class="filter-chkbox mt-8"
            v-if="$vuetify.breakpoint.smAndUp"
          ></v-checkbox>

          <v-text-field
            :label="$t('global.search_start_here')"
            v-model="search_params.any"
            @keydown="checkKeyPress"
            class="mt-8 ml-2"
            v-if="$vuetify.breakpoint.smAndUp"
            autocomplete="new-password"
          ></v-text-field>

          <v-autocomplete
            v-model="search_params.student_group_id"
            :items="studentgroups_filter"
            item-text="name"
            item-value="id"
            :label="$t('studentgroups.title')"
            @change="filter"
            clearable
            class="mt-8 ml-2"
            v-if="$vuetify.breakpoint.smAndUp"
            autocomplete="new-password"
          >
          </v-autocomplete>

          <v-autocomplete
            v-model="search_params.company_id"
            :items="enrolled_organisations_filter"
            item-text="name"
            item-value="id"
            :label="$t('enrolments.title_org')"
            @change="filter"
            clearable
            class="mt-8 ml-2"
            v-if="$vuetify.breakpoint.smAndUp"
            autocomplete="new-password"
          >
          </v-autocomplete>

          <router-link
            :to="BACKEND_URL + '/participants/create'"
            v-if="$can('participant-create') && !this.show_new_form_in_modal"
            class="ml-5"
          >
            <action-button type="new" small />
          </router-link>

          <action-button
            type="new"
            @click="showForm(null, 'participant')"
            v-if="$can('participant-create') && this.show_new_form_in_modal"
            small
          />
          <action-button type="save" @click="submit" small />
          <action-button type="cancel" @click="cancel" small />
        </v-app-bar>

        <v-divider></v-divider>

        <v-card-text class="py-0 mt-4">
          <v-data-table
            :headers="headers"
            :items="participants"
            :items-per-page="participants.length"
            :options.sync="pagination"
            :footer-props="{
              showFirstLastPage: true,
              'items-per-page-options': this.DATATABLE_ITEM_PER_PAGE_OPTIONS,
              'items-per-page-all-text': $t('global.items_per_page_all_text'),
              'items-per-page-text': $t('global.items_per_page_text'),
              'page-text': $t('global.page_text')
            }"
            :server-items-length="total"
            :loading="show_loading"
            :loading-text="$t('global.loading_text')"
            :no-data-text="$t('global.no_data_text')"
            :no-results-text="$t('global.no_results_text')"
            item-key="id"
            :show-select="true"
            v-model="selected"
            @toggle-select-all="toggleSelectAll($event)"
            :must-sort="true"
          >
            <template v-slot:header.data-table-select="{ props, on }">
              <v-simple-checkbox v-on="on" v-bind="props" />
              <span class="dt-selectall-count">({{ selectAll ? total : selected.length }})</span>
            </template>
            <template v-slot:item.date_of_birth="{ item }">
              {{ item.date_of_birth ? moment.utc(item.date_of_birth).format(DATE_FORMAT) : null }}
            </template>
            <template v-slot:item.company_id="{ item }">
              {{ item.companies ? item.companies.map((i) => i.name).join(", ") : "" }}
            </template>
          </v-data-table>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog v-model="showDialogForm" persistent max-width="75%">
      <div class="form-modal pa-4">
        <component
          :is="currentLoadedForm.form"
          :id="currentLoadedForm.id"
          :modal="true"
          :from_module="currentFromModule"
          :from_module_2="currentFromModule"
          @return_modal_form="return_modal_form"
          @return_modal_cancel_form="return_modal_cancel_form"
        ></component>
      </div>
    </v-dialog>
  </div>
</template>

<script>
export default {
  name: "ParticipantsListPopup",

  props: {
    show: {
      type: Boolean,
      required: true
    },
    except_ids: {
      type: Array
    },
    show_new_form_in_modal: {
      type: Boolean,
      default: false
    },
    sort_by: {
      type: String
    },
    from_module: {
      type: String
    }
  },

  components: {
    "participant-form": () => import("../../participants/components/Form")
  },

  data() {
    let sort_by = "first_name"
    if (this.sort_by) {
      sort_by = this.sort_by
    }

    return {
      url: "",
      selected: [],
      selectAll: false,
      participants: [],
      total: 0,
      all_ids: [],
      show_loading: false,
      show_filter: false,
      refresh: false,
      pagination: {
        itemsPerPage: this.$getSetting("rows_per_page"),
        sortBy: [sort_by],
        sortDesc: []
      },
      search_params: {
        not_in_ids: "",
        title: "",
        any: "",
        student_group_id: null,
        company_id: null,
        show_all: false,
        tenant_user_status: 1
      },

      currentFormId: "",
      currentForm: "",
      currentFromModule: "course",
      showDialogForm: false,

      studentgroups_filter: [],
      enrolled_organisations_filter: []
    }
  },

  computed: {
    headers: {
      get() {
        return [
          { text: this.$t("participants.first_name"), value: "first_name" },
          { text: this.$t("participants.last_name"), value: "last_name" },
          { text: this.$t("participants.date_of_birth"), value: "date_of_birth" },
          { text: this.$t("participants.email"), value: "email" },
          { text: this.$t("participants.mobile"), value: "mobile" },
          { text: this.$t("participants.company_id"), value: "company_id" }
        ]
      }
    },
    currentLoadedForm: function () {
      let form,
        id = null

      if (this.currentForm) {
        this.showDialogForm = true

        id = this.currentFormId
        form = this.currentForm
      }

      return {
        id: id,
        form: form
      }
    }
  },

  watch: {
    refresh: {
      handler() {
        if (this.refresh && this.show) {
          localStorage.setItem("__participantListSearchParams", JSON.stringify(this.search_params))
          this.list()
        }
      }
    },
    pagination: {
      handler() {
        if (this.search_params.any || this.search_params.student_group_id || this.search_params.company_id || this.search_params.show_all) {
          this.refresh = true
        }
      }
    },
    show: {
      handler(val) {
        if (val) {
          this.selected = []
          this.participants = []
        }
      }
    }
  },

  created() {
    this.url = this.API_URL + "participants"

    if (this.from_module) {
      this.currentFromModule = this.from_module
    }

    if (this.show) {
      if (localStorage.getItem("__participantListSearchParams")) {
        this.search_params = JSON.parse(localStorage.getItem("__participantListSearchParams"))
        if (this.search_params.any || this.search_params.student_group_id || this.search_params.company_id || this.search_params.show_all) {
          this.refresh = true
        }
      }

      this.ddlists()
    }
  },

  methods: {
    toggleSelectAll(event) {
      this.selectAll = event.value
      if (this.selectAll) {
        this.selected = []
        this.all_ids.forEach((id) => {
          this.selected.push({ id: id })
        })
      } else {
        this.selected = []
      }
    },
    list() {
      this.show_loading = true

      if (this.except_ids) {
        this.search_params.not_in_ids = this.except_ids.join(",")
      }

      let { sortBy, descending, page, itemsPerPage } = this.pagination
      let query = this.$queryString(this.pagination, this.search_params)

      axios.get(this.url + "?resourcetype=user-basic&" + query).then((res) => {
        this.participants = res.data.data
        this.total = res.data.meta.total
        this.refresh = false
        this.show_loading = false
        this.all_ids = res.data.meta.all_ids

        this.pagination.page = res.data.meta.current_page
        this.pagination.itemsPerPage = Number(res.data.meta.per_page)
      })
    },

    filter(target) {
      this.toggleSelectAll(false)

      if (this.search_params.any || this.search_params.student_group_id || this.search_params.company_id || this.search_params.show_all) {
        this.refresh = true
      } else {
        localStorage.setItem("__participantListSearchParams", JSON.stringify(this.search_params))

        this.participants = []
        this.total = 0
        this.refresh = false
        this.show_loading = false
        this.pagination = {
          page: 1,
          itemsPerPage: 0,
          itemsPerPage: this.$getSetting("rows_per_page"),
          sortBy: ["first_name"]
        }
      }
    },

    reset() {
      this.toggleSelectAll(false)
      this.refresh = true
    },

    cancel() {
      this.currentFormId = null
      this.currentForm = null
      this.showDialogForm = false
      this.$emit("callback_partlistpopup_cancel")
      this.reset()
    },

    submit() {
      this.$emit("callback_partlistpopup_submit", this.selected)
      this.reset()
    },

    ddlists() {
      axios
        .post(this.API_URL + "request/ddlists", [
          { key: "studentgroups", module: "studentgroups", query: "show_all=true" },
          { key: "enrolled_organisations", module: "enrolled_organisations", query: "show_all=true" }
        ])
        .then((res) => {
          this.studentgroups_filter = res.data.studentgroups
          this.enrolled_organisations_filter = res.data.enrolled_organisations
        })
    },

    checkKeyPress(e) {
      if (e.key == "Enter") {
        this.filter()
      }
    },

    showForm(id, type) {
      this.currentFormId = id
      this.currentForm = type + "-form"
    },
    return_modal_form(data) {
      var data = data.data || null

      if (data) {
        this.selected = [data]
        this.submit()
      }

      this.cancel()
    },
    return_modal_cancel_form() {
      this.cancel()
    }
  }
}
</script>

<style>
.filter-chkbox.v-input--checkbox .v-label {
  color: #fff !important;
}
</style>
